import React from "react";
import { Button, Flex, Text } from "@radix-ui/themes";
import { IconArrowBack } from "@tabler/icons-react";
import { exitImpersonation } from "@/services/user";
import useUser from "@/lib/useUser";

const ExitImpersonationBanner: React.FC = () => {
  const { user } = useUser();

  // Don't show banner if not impersonating
  if (!user?.impersonation?.isImpersonating) {
    return null;
  }

  const handleExitImpersonation = async () => {
    try {
      await exitImpersonation();
    } catch (error) {
      console.error("Failed to exit impersonation:", error);
      alert("Failed to exit impersonation. Please try again.");
    }
  };

  return (
    <Flex
      direction="row"
      align="center"
      justify="center"
      gap="3"
      p="3"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "var(--orange-9)",
        color: "white",
        zIndex: 9999,
        borderBottom: "1px solid var(--orange-10)",
      }}
    >
      <Text size="2" weight="medium">
        You are impersonating {user.impersonation.impersonatedUserEmail}
      </Text>
      <Button
        variant="ghost"
        size="1"
        onClick={handleExitImpersonation}
        style={{
          color: "white",
          backgroundColor: "transparent",
          border: "1px solid rgba(255, 255, 255, 0.3)",
        }}
      >
        <IconArrowBack size={14} />
        Exit Impersonation
      </Button>
    </Flex>
  );
};

export default ExitImpersonationBanner;
